"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
/*
* this component check if itself has passed through viewport
* by scrolling down
* setting offset can shift the detect earlier
*/
function ScrollThroughViewportDetector(props) {
    var onScrollThrough = props.onScrollThrough, _a = props.offset, offset = _a === void 0 ? 0 : _a;
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var checkScrolledThrough = function () {
            if (ref.current) {
                var rect = ref.current.getBoundingClientRect();
                // TODO: check horizontal scroll
                var isScrolledThrough = rect.top - offset < document.documentElement.clientHeight;
                if (isScrolledThrough) {
                    onScrollThrough(ref.current);
                }
            }
        };
        // initial check when first load
        checkScrolledThrough();
        window.addEventListener('scroll', checkScrolledThrough);
        return function () {
            window.removeEventListener('scroll', checkScrolledThrough);
        };
    }, [offset, onScrollThrough]);
    return react_1.default.createElement("div", { ref: ref });
}
exports.default = ScrollThroughViewportDetector;
